<!-- Floating Button -->
<div
  class="fixed bottom-2 right-2 z-50 cursor-pointer"
  (click)="toggle()"
>
  <img
    src="assets/img/logo/whatsapp-icon.svg"
    class="w-14 h-14 drop-shadow-lg hover:scale-105 transition"
  />
</div>

<!-- Chat Widget -->
<div
  *ngIf="isOpen"
  class="fixed bottom-24 right-6 w-72 bg-white rounded-xl shadow-xl border z-50"
>

  <!-- Header -->
  <div class="bg-green-500 text-white p-3 rounded-t-xl flex justify-between">
    <span>Support</span>
    <button (click)="toggle()">✕</button>
  </div>

  <!-- Auto Message -->
  <div class="p-3 text-sm bg-gray-50">
    Hello! How can we assist you today?
  </div>

  <!-- Input -->
  <div class="p-3 space-y-2">

    <input
      [(ngModel)]="message"
      placeholder="Type your message..."
      class="w-full border rounded px-3 py-2 outline-none focus:ring"
    />

    <button
      (click)="sendWhatsApp()"
      class="w-full bg-green-500 text-white py-2 rounded hover:bg-green-600 transition"
    >
      Send
    </button>

  </div>

</div>
